import { DependencyList, useMemo, useRef } from 'react';
import { PromiseLifecycle, promiseLifecycle } from '../promise-lifecycle';

export type PromiseWrapper = <T>(promise: Promise<T>) => Promise<T>;

export function usePromise(deps?: DependencyList): PromiseWrapper {
  const ref = useRef<PromiseLifecycle | undefined>();

  return useMemo<PromiseWrapper>(() => {
    const current = {
      alive: true,
    };

    if (ref.current) {
      ref.current.alive = false;
    }

    ref.current = current;

    return (promise) => promiseLifecycle(current, promise);
  }, deps);
}
